import type { RenderItem } from 'three';

/** Respect authored layers, then submit opaque occluders from front to back.
 * Material-first sorting shaded dense cover behind rocks/terrain before those
 * occluders could fill depth. Transparent sky/water sorting stays independent. */
export function opaqueFrontToBack(a: RenderItem, b: RenderItem): number {
  return a.groupOrder - b.groupOrder || a.renderOrder - b.renderOrder
    || a.z - b.z || a.material.id - b.material.id || a.id - b.id;
}
